import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';

interface PrivateRouteProps {
  children: React.ReactElement;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  // 開發環境下直接允許訪問所有頁面
  if (import.meta.env.VITE_ENVIRONMENT === 'development') {
    return children;
  }
  
  // 正常環境下檢查兩階段登入是否完成
  // 需要有 accessToken 和 currentVendorId 才算完整登入
  const isFullyAuthenticated = isAuthenticated();
  
  if (!isFullyAuthenticated) {
    // 清理可能殘留的臨時數據
    sessionStorage.removeItem('preAuthToken');
    sessionStorage.removeItem('loginUser');
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default PrivateRoute;
